export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-nexusapi.blockchainx.tech',
  appVersion: '1.0.0',
  // Social sign-in (shared with the user app — same Google/Apple projects).
  googleClientId: '127818760057-73g6l76nq1u8ki1lbkn5k4n77k42f516.apps.googleusercontent.com',
  appleClientId: 'com.hashbook',
  appleRedirectUri: 'https://dev-nexus.blockchainx.tech/auth/login',
  // Sentry error monitoring. Empty = OFF — Sentry runs in PRODUCTION only.
  sentryDsn: ''
};
